import { openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';

export const openLitresSuccessDialog = () => openPopupHelper({ popupName: popupNames.LITRES_SUCCESS_DIALOG });
